export class PasswordResetRequest {
  username = "";
  email = "";
  confirmEmail = "";
  token = "";
  password = "";
  confirmPassword = "";
  currentPassword = "";
}
